import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollDeductionDetailDTO  {
    _originalTypeClassName = "zERP.BO.PayrollDeductionDetailDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollDeductionDetailDTO.translate = translateService;
}
this.Id = null;
this.EmployeeAmount = null;
this.EmployeeParameterValue = null;
this.EmployerAmount = null;
this.EmployerParameterValue = null;
this.PayrollDeductionDetailDTOKey = null;
this._key = this.PayrollDeductionDetailDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
EmployeeAmount:any;
EmployeeParameterValue:any;
EmployerAmount:any;
EmployerParameterValue:any;
RuleDTO:any;
private _PayrollDeductionDetailDTOKey:any;
get PayrollDeductionDetailDTOKey(): any {
    return this._PayrollDeductionDetailDTOKey;
  }
set PayrollDeductionDetailDTOKey(value: any) {
    this._PayrollDeductionDetailDTOKey = value;
    this._key = value;
  }
static setRuleDTO = ($this, value) => {
var oldValue = $this.RuleDTO;
$this.RuleDTO = value;
if (value != null) {
}
}

static Assign(pdd: any): any{let pddDTO = new Domain.PayrollDeductionDetailDTO();
pddDTO.Id = pdd?.Id;
pddDTO.EmployeeAmount = pdd?.EmployeeAmount;
pddDTO.EmployeeParameterValue = pdd?.EmployeeParameterValue;
pddDTO.EmployerAmount = pdd?.EmployerAmount;
pddDTO.EmployerParameterValue = pdd?.EmployerParameterValue;
Domain.PayrollDeductionDetailDTO.setRuleDTO(pddDTO, Domain.RuleDTO.AssignDeduction(pdd?.Rule));
return pddDTO;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollDeductionDetailDTOKey == null || $this.PayrollDeductionDetailDTOKey == 0;
            }


}